/** @jsx jsx */

import { Fragment as _, useState } from 'react';
import { css, jsx, keyframes } from '@emotion/core';

const HotSpotTickedWhenSeen = props => {
  const {
    x,
    y,
    size,
    inverseScale,
    color = '#00D9D3',
    displayAsRadio = false,
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x={x}
      y={y}
      fill="none"
      overflow="visible"
      css={css({
        '*': {
          transform: `scale(${inverseScale})`,
        },
        pointerEvents: 'none',
      })}
    >
      <circle
        cx={0}
        cy={0}
        r={10}
        style={{
          fill: '#fff',
          WebkitFilter: `drop-shadow(0 0 4px rgba(0, 0, 0, 0.15))`,
          filter: `drop-shadow(0 0 4px rgba(0, 0, 0, 0.15))`,
        }}
      />
      {displayAsRadio ? (
        <svg overflow="visible" x={0} y={0}>
          <circle
            cx={0}
            cy={0}
            r={10}
            style={{
              fill: color,
              transform: 'scale(0.8)',
            }}
          />
        </svg>
      ) : (
        <svg overflow="visible" x={-5} y={-4}>
          <path
            d="M1.21741 3.93192L4.06313 6.51129L8.99789 0.838809"
            style={{
              stroke: color,
              strokeWidth: 2,
              transformOrigin: '5px 4px',
            }}
          />
        </svg>
      )}
    </svg>
  );
};

export { HotSpotTickedWhenSeen };
